import type { TDataExportStoreState } from 'App/data-export/store/dataExportStore'
import { filterUniqueAndMapToValueAndLabel } from 'App/data-export/store/selectors/_utils/filterUniqueAndMapToValueAndLabel'
import { getValueTypesForFieldAssetIdsWithPropertyId } from 'App/data-export/store/selectors/_utils/getValueTypesForFieldAssetIdsWithPropertyId'
import { mapAggregationToLabel } from 'App/data-export/store/selectors/_utils/mapAggregationToLabel'
import type { TDataExportValueTypesTimeseriesAggregation } from 'App/data-export/types/from-code-gen/TDataExportValueTypesTimeseriesAggregation'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'

export const intervalAndValueTypesOptions = ({
  propertyId,
  points,
  blockIds,
  irrigationZoneEmitterIds,
  interval,
  fieldAssetStoreState,
}: {
  propertyId: TDataExportStoreState['formState']['propertyId']
  points: TDataExportStoreState['formState']['points']
  blockIds: TDataExportStoreState['formState']['blockIds']
  irrigationZoneEmitterIds: TDataExportStoreState['formState']['irrigationZoneEmitterIds']
  interval: TDataExportStoreState['formState']['interval']
  fieldAssetStoreState: TFieldAssetStoreState
}) => {
  const valueTypesForSelectedFieldAssets = getValueTypesForFieldAssetIdsWithPropertyId({
    propertyId,
    lngLats: points,
    blockIds,
    irrigationZoneEmitterIds,
    fieldAssetStoreState,
  })

  const intervalOptions = filterUniqueAndMapToValueAndLabel({
    items: valueTypesForSelectedFieldAssets,
    uniqueBy: (x) => x.interval,
    mapToLabel: (x) => mapAggregationToLabel[x.interval as TDataExportValueTypesTimeseriesAggregation](),
  })

  const valueTypesOptions = interval
    ? valueTypesForSelectedFieldAssets.filter((x) => x.interval === interval)
    : []

  return {
    intervalOptions,
    valueTypesOptions,
  }
}
